import { cn } from "@/utils/cn";
import type { SummarizedListSectionGap } from "./SummarizedListSectionTemplate.types";

const gapByDensity: Record<SummarizedListSectionGap, string> = {
  normal: "space-y-4",
  relaxed: "space-y-6",
};

export function summarizedListSectionReadyStackClass(
  gap: SummarizedListSectionGap,
  className?: string
): string {
  return cn(gapByDensity[gap], className);
}

export const summarizedListSectionLoadingRootClass =
  "flex flex-col items-center justify-center py-8";

export const summarizedListSectionLoadingSpinnerClass =
  "mb-3 h-8 w-8 animate-spin rounded-full border-4 border-gradient-purple border-t-transparent";

export const summarizedListSectionErrorRootClass =
  "rounded-xl border border-red/30 bg-gradient-to-r from-red/10 to-light-red/20 p-4 shadow-sm";

export const summarizedListSectionErrorIconWellClass = "rounded-lg bg-red/20 p-2";

export const summarizedListSectionErrorBodyClass = "flex items-start gap-3";
